<template>
  <router-link
    to="/home"
    :class="['desktop-brand-corner', { 'is-inline': inline }]"
    aria-label="返回首页"
    @click.stop
  >
    <span class="desktop-brand-icon" aria-hidden="true">
      <font-awesome-icon icon="seedling" />
    </span>
    <span class="desktop-brand-name">树苗英语</span>
  </router-link>
</template>

<script>
export default {
  props: {
    inline: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style scoped>
.desktop-brand-corner {
  position: absolute;
  top: var(--brand-corner-top, 8px);
  left: var(--brand-corner-left, 24px);
  z-index: 105;
  min-height: 58px;
  padding: 0;
  background: transparent;
  box-shadow: none;
  display: inline-flex;
  align-items: center;
  gap: 12px;
  text-decoration: none;
  transition: transform 0.25s ease, opacity 0.25s ease;
}

.desktop-brand-corner.is-inline {
  position: relative;
  top: auto;
  left: auto;
}

.desktop-brand-corner:hover {
  transform: translateY(-1px);
  opacity: 0.92;
}

.desktop-brand-icon {
  width: 38px;
  height: 38px;
  border-radius: 12px;
  background: linear-gradient(135deg, #ff8a3d 0%, #ff6b35 100%);
  box-shadow: 0 8px 16px rgba(255, 128, 51, 0.26);
  display: inline-flex;
  align-items: center;
  justify-content: center;
  color: #ffffff;
  font-size: 19px;
  flex-shrink: 0;
}

.desktop-brand-name {
  color: #2d3436;
  font-size: 18px;
  font-weight: 800;
  line-height: 1;
  white-space: nowrap;
}

@media (max-width: 768px) {
  .desktop-brand-corner {
    display: none;
  }
}
</style>
